export default __webpack_public_path__ + "/dist/images/9001287.png";